import type { ReactNode } from "react";
import {
  useThumbnail,
  type ThumbnailKind,
} from "@/features/coach-review/hooks/useThumbnail";

export type FeedbackMediaThumbnailProps = {
  kind: ThumbnailKind;
  id: number | null;
  className: string;
  testId: string;
  placeholderTestId: string;
  imgClassName?: string;
  children?: ReactNode;
};

/** Shared auth-fetched note/clip thumbnail tile.
 *
 * Note and clip thumbnails are private JPEG blobs served through the
 * coach thumbnail endpoints, so every surface must use `useThumbnail`
 * rather than direct `<img src="/api/...">` URLs. Children render as
 * overlays, used by video-note rows that need saved telestration marks
 * on top of the server frame.
 */
export function FeedbackMediaThumbnail({
  kind,
  id,
  className,
  testId,
  placeholderTestId,
  imgClassName = "block h-full w-full object-cover",
  children,
}: FeedbackMediaThumbnailProps) {
  const url = useThumbnail(kind, id);
  return (
    <span
      aria-hidden="true"
      className={className}
      data-testid={url ? testId : placeholderTestId}
    >
      {url ? <img src={url} alt="" className={imgClassName} /> : null}
      {children}
    </span>
  );
}
